import dotenv from "dotenv";
dotenv.config(); // .envをprocess.envに割当て

type Config = {
    apiUrl: string;
    tokenUrl: string;
    baseUrl: string;
    clientId: string;
    clientSecret: string;
    limitRetryCount: number;
    retryDelay: number;
};

// TODO:設定値が増えた際に追加漏れが発生しないよう工夫したい
[
    `REACT_APP_API_URL`,
    `REACT_APP_TOKEN_URL`,
    `REACT_APP_BASE_URL`,
    `REACT_APP_CLIENT_ID`,
    `REACT_APP_CLIENT_SECRET`,
    `REACT_APP_LIMIT_RETRY_COUNT`,
    `REACT_APP_RETRY_DELAY`,
]
    .filter((key) => process.env[key] === undefined || process.env[key] === ``)
    .forEach((key) => {
        console.error(`Error: "${key}" is not set.`);
    });

const apiUrl = process.env.REACT_APP_API_URL || ``;
const tokenUrl = process.env.REACT_APP_TOKEN_URL || ``;
const baseUrl = process.env.REACT_APP_BASE_URL || ``;
const clientId = process.env.REACT_APP_CLIENT_ID || ``;
const clientSecret = process.env.REACT_APP_CLIENT_SECRET || ``;
const limitRetryCount = process.env.REACT_APP_LIMIT_RETRY_COUNT || ``;
const retryDelay = process.env.REACT_APP_RETRY_DELAY || ``;

export const config: Config = {
    apiUrl,
    tokenUrl,
    baseUrl,
    clientId,
    clientSecret,
    limitRetryCount: !isNaN(parseInt(limitRetryCount)) ? parseInt(limitRetryCount) : 0,
    retryDelay: !isNaN(parseInt(retryDelay)) ? parseInt(retryDelay) : 0,
};
